import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { User } from '@playbook/models';
@StoreConfig({ name: 'user' })
@Injectable({ providedIn: 'root' })
export class UserStore extends Store<User> {
  constructor() {
    super({});
  }
}
